import React from 'react';

export default {
	'Error.Unknown': 'Erreur inconnue',
	'Error.Unknown.Message': 'Une erreur s\'est produite.',
	'Error.NotFound': 'Introuvable',
	'Error.NotFound.Message': 'La page demandée est introuvable.',
	'Error.Forbidden': 'Interdite',
	'Error.Forbidden.Message': 'Vous n\'êtes pas autorisé à accéder à cette page.',
	'Error.Invalid': 'Entrée invalide',
	'Error.Invalid.Message': 'Champs invalides : {{fields}}.',
	'Error.FileSize.Message': 'Le fichier que vous avez essayé de télécharger était trop volumineux.',
	'PTMD Portal': 'PTMD Portail',
	'Login': 'Se connecter',
	'Logout': 'Déconnexion',
	'FileDrop.Release': 'Relâchez pour sélectionner le fichier',
	'FileDrop.Drag': () => <h5>Glissez-déposez un fichier ici<br/> ou </h5>,
	'FileDrop.Select': 'Sélectionnez un fichier',
	'GiB': '{{size}} Gio',
	'MiB': '{{size}} Mio',
	'KiB': '{{size}} Kio',
	'bytes': '{{size}} octets',
	'FileSize.Max': 'La taille maximale des fichiers à télécharger est de {{size}}',
	'Modal.Open': 'Ouvrir',
	'Modal.Close': 'Fermer',
	'Language': 'Langue'
};
